// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1QXKj","cell":"ColumnAccessor_cell__1mTuf","firstCellAccent":"ColumnAccessor_firstCellAccent__2zpe_"};